import React, { useEffect } from "react";
import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { AppDispatch, RootReducerType, RootState } from "@store/store";
import { useDispatch, useSelector } from "react-redux";
import UndertakingDetailConsent from "@modules/stepper/components/UndertakingDetailConsent";

export const Consent: React.FC<{
  isExpanded: boolean;
  toggleExpand: () => void;
}> = ({ isExpanded, toggleExpand }) => {
  const { uploadDocuments } = useSelector(
    (state: RootState) => state.uploadedDocuments,
  );

  const undertakingDocs =
    uploadDocuments?.files?.filter(
      (doc: any) => doc.document_type === "UNDERTAKING",
    ) || [];

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Card sx={{ boxShadow: "none", border: "1px solid #E7E8E9", p: 0 }}>
        <Box
          sx={{
            backgroundColor: "#F4F2F7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pl: 2,
            borderBottom: "1px solid #E7E8E9",
            py: "5px"
          }}
          onClick={toggleExpand}
        >
          <Typography
            className="preview-dropdown-header"
            sx={{ fontSize: 12 }}
            fontWeight="semi-bold"
          >
            Undertakings & Consents
          </Typography>
          <IconButton aria-label="Collapse section">
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>
        {isExpanded && (
          <Box px={1}>
            <UndertakingDetailConsent underTacking={undertakingDocs} />
          </Box>
        )}
      </Card>
    </Box>
  );
};
